/*Edit thong tin ve nguon tin va tai nan, phuong tien bi nan */
import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Input from "@material-ui/core/Input";
import MaskedInput from "react-text-mask";
import PropTypes from "prop-types";
import SelectFilter from "react-select";
import Select from "@material-ui/core/Select";
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import CircularProgress from "@material-ui/core/CircularProgress";
import MyLatLonEditor from "./LatLonEditor";
import TaiNanEditDialog from "../danhmuc/TaiNanEditDialog";

import {
  DatePicker,
  TimePicker,
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
} from "@material-ui/pickers";

import moment from "moment";

import MyButton from "../MyButton";

const myLib = require("../../lib/MyLib");
const server = require("../../lib/server");
const sukienLayer = require("../../lib/SuKienDataLayer");
///////////////////////////////////////////////////////////////////

const defaultRecord = {
  MaTN: null,
  TinhTrang: '',
  TomTat: '',
  MoTa: '',
};
class SuKienTinhChatControl extends React.Component {
  constructor(props) {
    super(props);
    this.saveField = this.saveField.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.state = {
      canSaved: false, //cho phep save hay khong
      dataChanged: false, //du lieu co su thay doi hay khong
      saving: false, //co dang save du lieu hay khong
      errorLog: "", //mo ta loi neu co
      //danh muc tinh chat tai nan
      loading_tainan: true, // co dang loading danh muc quoc gia khong
      source_tainan: [], //danh muc options cho quoc tich
      before:
        props.value === undefined
          ? {
              ThoiGian: new Date(),
            }
          : myLib.cloneObject(props.value), //thong tin truoc khi edit
      after:
        props.value === undefined
          ? defaultRecord
          : { ...defaultRecord, ...props.value }, //thong tin dang edit
      validateStatus: {},
    };
  }
  //ghi nhan gia tri nhap
  saveField = (fieldName, value) => {
    var old_changed = this.state.dataChanged;
    var s = this.state;
    s.after[fieldName] = value;
    s.dataChanged = !myLib.isSame(s.before, s.after, [
      "MaTN",
      "TinhTrang",
      "TomTat",
      "MoTa",
    ]);
    s.canSaved = s.dataChanged;
    console.log(s);
    if(this.props.onChanged && old_changed != s.dataChanged) {
      this.props.onChanged(s.dataChanged);
    }
    this.setState(s);
  };
  //submit thong tin ve DB
  handleSave = () => {
    console.log(JSON.stringify(this.state.after));
    var check = sukienLayer.validate("tinhchat", this.state.after);
    if (!check.error) {
      this.setState({ validateStatus: check, saving: true, errorLog: "" });
      server
        .post(
          "sukien/saveTinhchat",
          sukienLayer.chuanHoaSukien("tinhchat", this.state.after)
        )
        .then((response) => {
          var before = {};
          var after = this.state.after;
          Object.assign(before, after);
          this.setState({
            before: before,
            after: after,
            dataChanged: false,
            canSaved: false,
            saving: false,
            errorLog: "",
          });
          //thong bao cho parent biet co data duoc saved
          if (this.props.onSaved) {
            this.props.onSaved(after);
          }
          if(this.props.onChanged) {
            this.props.onChanged(false);
          }
        })
        .catch((error) =>
          this.setState({ saving: false, errorLog: error + "" })
        );
    } else {
      this.setState({ validateStatus: check });
    }
  };
  loadDanhMuc() {
    //load danh muc tai nan
    server
      .query("tainan/getall")
      .then((response) => {
        var list = [];
        response.map((item, index) =>
          list.push({ value: item.MaTN, label: item.TenTaiNan })
        );
        this.setState({ source_tainan: list, loading_tainan: false });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading_tainan: false });
      });
  }
  //khi load component: load cac danh muc can thiet
  componentDidMount() {
    this.loadDanhMuc();
  }
  static getDerivedStateFromProps(props, state) {
    var newState = { ...state };
    //console.log("TaiNanControl props:", props.value);
    if (props.value !== undefined && props.value.MaSK !== state.after.MaSK) {
      //console.log("co su thay doi");
      //co su thay doi
      newState = {
        ...newState,
        after: { ...state.after, ...props.value },
      }; //lay thong tin tu parent form truyen vao thong qua props
    }
    //console.log("TaiNanControl new state:", newState);
    return newState;
  }
  render() {
    const { classes, theme } = this.props;
    return (
      <Accordion
        disabled={this.props.disabled}
        defaultExpanded={this.props.value !== undefined}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          classes={{
            root: classes.normalPanel,
            expanded: classes.expandedPanel,
            content: classes.summaryContent,
          }}
        >
          <Typography className={classes.heading}>Mô tả sự vụ</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={2}>
              <InputLabel
                id="labelTainan"
                className={
                  this.state.validateStatus.MaTN !== undefined
                    ? classes.labelError
                    : classes.label
                }
                onClick={
                  global.User.Quyen.R171
                    ? (event) => this.setState({ open_them_tainan: true })
                    : undefined
                }
              >
                Tai nạn(*):
              </InputLabel>
              {this.state.loading_tainan ? (
                <CircularProgress />
              ) : (
                <SelectFilter
                  id="cboMaTN"
                  options={this.state.source_tainan}
                  placeholder="---Chọn---"
                  labelId="labelTainan"
                  value={this.state.after.MaTN}
                  onChange={(item) => this.saveField("MaTN", item)}
                ></SelectFilter>
              )}
            </Grid>
            <Grid item xs={5}>
              <InputLabel
                id="labelNoidung"
                className={
                  this.state.validateStatus.TinhTrang !== undefined
                    ? classes.labelError
                    : classes.label
                }
              >
                Tình trạng:
              </InputLabel>
              <TextareaAutosize
                id="txtTinhTrang"
                labelId="labelNoidung"
                aria-label="Tình trạng:"
                className={classes.noidung}
                value={this.state.after.TinhTrang}
                InputProps={{
                  maxLength: 500,
                  className: classes.noidung,
                }}
                rowsMin={7}
                onChange={(event) =>
                  this.saveField("TinhTrang", event.target.value)
                }
                error={this.state.validateStatus.TinhTrang !== undefined}
                helperText={
                  this.state.validateStatus.TinhTrang !== undefined
                    ? this.state.validateStatus.TinhTrang.trangthai
                    : undefined
                }
              />
            </Grid>
            <Grid item xs={5}>
            <InputLabel
                id="labelNoidung"
                className={
                  this.state.validateStatus.TomTat !== undefined
                    ? classes.labelError
                    : classes.label
                }
              >
                Tóm tắt:
              </InputLabel>
              <TextareaAutosize
                id="txtTomTat"
                labelId="labelNoidung"
                aria-label="Tình trạng:"
                className={classes.noidung}
                value={this.state.after.TomTat}
                InputProps={{
                  maxLength: 1024,
                  className: classes.noidung,
                }}
                rowsMin={7}
                onChange={(event) =>
                  this.saveField("TomTat", event.target.value)
                }
                error={this.state.validateStatus.TomTat !== undefined}
                helperText={
                  this.state.validateStatus.TomTat !== undefined
                    ? this.state.validateStatus.TomTat.trangthai
                    : undefined
                }
              />
            </Grid>
            <Grid item xs={2}></Grid>
            <Grid item xs={10}>
            <InputLabel
                id="labelNoidung"
                className={
                  this.state.validateStatus.MoTa !== undefined
                    ? classes.labelError
                    : classes.label
                }
              >
                Mô tả chi tiết:
              </InputLabel>
              <TextareaAutosize
                id="txtMoTa"
                labelId="labelNoidung"
                aria-label="Mô tả chi tiết:"
                className={classes.noidung2}
                value={this.state.after.MoTa}
                InputProps={{
                  maxLength: 10240,
                  className: classes.noidung,
                }}
                rowsMin={7}
                onChange={(event) =>
                  this.saveField("MoTa", event.target.value)
                }
                error={this.state.validateStatus.MoTa !== undefined}
                helperText={
                  this.state.validateStatus.MoTa !== undefined
                    ? this.state.validateStatus.MoTa.trangthai
                    : undefined
                }
              />
            </Grid>
            <Grid item xs={4}>
              {this.state.canSaved ? (
                <MyButton
                  onClick={this.handleSave}
                  color="primary"
                  text="Lưu"
                />
              ) : null}
            </Grid>
            <Grid item xs={10}>
              {this.state.saving ? (
                <CircularProgress />
              ) : this.state.errorLog === "" ? null : (
                this.state.errorLog
              )}
            </Grid>
          </Grid>
          {this.state.open_them_tainan ? (
            <TaiNanEditDialog
              visible={this.state.open_them_tainan}
              fullWidth={true}
              maxWidth={"sm"}
              EditMode="them"
              onClose={(result) => {
                this.setState({ open_them_tainan: false });
              }}
              onSaved={(record) => {
                var list = [].concat(this.state.source_tainan);
                var new_item = {
                  value: record.MaTN,
                  label: record.TenTaiNan,
                };
                list.unshift(new_item);
                this.setState({
                  source_tainan: list,
                  dataChanged: true,
                  canSaved: true,
                  after: { ...this.state.after, MaTN: new_item },
                });
              }}
            />
          ) : null}
        </AccordionDetails>
      </Accordion>
    );
  }
}
const styles = (theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
    heigh: "fit-content",
  },
  formControl: {
    marginTop: 2,
    minWidth: 120,
  },

  thoigian: {
    marginLeft: 1,
    marginRight: 1,
    width: 200,
  },
  textbox: {
    marginLeft: 1,
    marginRight: 1,
    width: "100%",
  },
  uppercaseText: {
    textTransform: "uppercase",
  },
  normalPanel: {
    backgroundColor: "lightskyblue",
    margin: 0,
    minHeight: 11,
  },
  expandedPanel: {
    backgroundColor: "skyblue",
    margin: 0,
    minHeight: '10px !important',
  },
  summaryContent: {
    margin: '1px !important',
  },
  normalLabel: {
    color: "black",
  },
  redLabel: {
    color: "red",
  },
  noidung: {
    height: 100,
    width: 500,
  },
  noidung2: {
    height: 100,
    width: 1020,
  },
  label: {
    margin: 6,
  },
  labelError: {
    margin: 6,
    color: "red",
  },
});
export default withStyles(styles, { withTheme: true })(SuKienTinhChatControl);
